webpackJsonp([17],{

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(157);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(232);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.timeout = 500000;
_axios2.default.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
_axios2.default.defaults.transformRequest.get = [function (data) {
  var newData = '';
  for (var k in data) {
    newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
  }
  return newData;
}];
exports.default = {
  fetchGet: function fetchGet(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new _promise2.default(function (resolve, reject) {
      _axios2.default.get(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  fetchPost: function fetchPost(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new _promise2.default(function (resolve, reject) {
      _axios2.default.post(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  fetchPut: function fetchPut(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new _promise2.default(function (resolve, reject) {
      _axios2.default.put(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _message = __webpack_require__(600);

var _message2 = _interopRequireDefault(_message);

var _message3 = __webpack_require__(551);

var _message4 = _interopRequireDefault(_message3);

var _notification = __webpack_require__(601);

var _notification2 = _interopRequireDefault(_notification);

var _notification3 = __webpack_require__(552);

var _notification4 = _interopRequireDefault(_notification3);

var _loading = __webpack_require__(596);

var _loading2 = _interopRequireDefault(_loading);

var _loading3 = __webpack_require__(544);

var _loading4 = _interopRequireDefault(_loading3);

var _option = __webpack_require__(602);

var _option2 = _interopRequireDefault(_option);

var _option3 = __webpack_require__(217);

var _option4 = _interopRequireDefault(_option3);

var _select = __webpack_require__(609);

var _select2 = _interopRequireDefault(_select);

var _select3 = __webpack_require__(218);

var _select4 = _interopRequireDefault(_select3);

var _dialog = __webpack_require__(587);

var _dialog2 = _interopRequireDefault(_dialog);

var _dialog3 = __webpack_require__(536);

var _dialog4 = _interopRequireDefault(_dialog3);

var _input = __webpack_require__(594);

var _input2 = _interopRequireDefault(_input);

var _input3 = __webpack_require__(74);

var _input4 = _interopRequireDefault(_input3);

var _tableColumn = __webpack_require__(615);

var _tableColumn2 = _interopRequireDefault(_tableColumn);

var _tableColumn3 = __webpack_require__(564);

var _tableColumn4 = _interopRequireDefault(_tableColumn3);

var _table = __webpack_require__(616);

var _table2 = _interopRequireDefault(_table);

var _table3 = __webpack_require__(565);

var _table4 = _interopRequireDefault(_table3);

var _step = __webpack_require__(611);

var _step2 = _interopRequireDefault(_step);

var _step3 = __webpack_require__(560);

var _step4 = _interopRequireDefault(_step3);

var _steps = __webpack_require__(612);

var _steps2 = _interopRequireDefault(_steps);

var _steps3 = __webpack_require__(561);

var _steps4 = _interopRequireDefault(_steps3);

var _autocomplete = __webpack_require__(574);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _autocomplete3 = __webpack_require__(524);

var _autocomplete4 = _interopRequireDefault(_autocomplete3);

var _icon = __webpack_require__(592);

var _icon2 = _interopRequireDefault(_icon);

var _icon3 = __webpack_require__(540);

var _icon4 = _interopRequireDefault(_icon3);

var _checkbox = __webpack_require__(582);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _checkbox3 = __webpack_require__(102);

var _checkbox4 = _interopRequireDefault(_checkbox3);

var _pagination = __webpack_require__(604);

var _pagination2 = _interopRequireDefault(_pagination);

var _pagination3 = __webpack_require__(554);

var _pagination4 = _interopRequireDefault(_pagination3);

var _menuItem = __webpack_require__(598);

var _menuItem2 = _interopRequireDefault(_menuItem);

var _menuItem3 = __webpack_require__(549);

var _menuItem4 = _interopRequireDefault(_menuItem3);

var _submenu = __webpack_require__(613);

var _submenu2 = _interopRequireDefault(_submenu);

var _submenu3 = __webpack_require__(562);

var _submenu4 = _interopRequireDefault(_submenu3);

var _menu = __webpack_require__(599);

var _menu2 = _interopRequireDefault(_menu);

var _menu3 = __webpack_require__(550);

var _menu4 = _interopRequireDefault(_menu3);

var _carouselItem = __webpack_require__(580);

var _carouselItem2 = _interopRequireDefault(_carouselItem);

var _carouselItem3 = __webpack_require__(529);

var _carouselItem4 = _interopRequireDefault(_carouselItem3);

var _carousel = __webpack_require__(581);

var _carousel2 = _interopRequireDefault(_carousel);

var _carousel3 = __webpack_require__(530);

var _carousel4 = _interopRequireDefault(_carousel3);

var _drawer = __webpack_require__(590);

var _drawer2 = _interopRequireDefault(_drawer);

var _drawer3 = __webpack_require__(538);

var _drawer4 = _interopRequireDefault(_drawer3);

var _col = __webpack_require__(583);

var _col2 = _interopRequireDefault(_col);

var _col3 = __webpack_require__(532);

var _col4 = _interopRequireDefault(_col3);

var _row = __webpack_require__(608);

var _row2 = _interopRequireDefault(_row);

var _row3 = __webpack_require__(558);

var _row4 = _interopRequireDefault(_row3);

var _pageHeader = __webpack_require__(603);

var _pageHeader2 = _interopRequireDefault(_pageHeader);

var _pageHeader3 = __webpack_require__(553);

var _pageHeader4 = _interopRequireDefault(_pageHeader3);

var _divider = __webpack_require__(589);

var _divider2 = _interopRequireDefault(_divider);

var _divider3 = __webpack_require__(537);

var _divider4 = _interopRequireDefault(_divider3);

var _image = __webpack_require__(593);

var _image2 = _interopRequireDefault(_image);

var _image3 = __webpack_require__(541);

var _image4 = _interopRequireDefault(_image3);

var _collapseItem = __webpack_require__(584);

var _collapseItem2 = _interopRequireDefault(_collapseItem);

var _collapseItem3 = __webpack_require__(533);

var _collapseItem4 = _interopRequireDefault(_collapseItem3);

var _collapse = __webpack_require__(585);

var _collapse2 = _interopRequireDefault(_collapse);

var _collapse3 = __webpack_require__(534);

var _collapse4 = _interopRequireDefault(_collapse3);

var _aside = __webpack_require__(573);

var _aside2 = _interopRequireDefault(_aside);

var _aside3 = __webpack_require__(523);

var _aside4 = _interopRequireDefault(_aside3);

var _header = __webpack_require__(591);

var _header2 = _interopRequireDefault(_header);

var _header3 = __webpack_require__(539);

var _header4 = _interopRequireDefault(_header3);

var _main = __webpack_require__(597);

var _main2 = _interopRequireDefault(_main);

var _main3 = __webpack_require__(548);

var _main4 = _interopRequireDefault(_main3);

var _tag = __webpack_require__(618);

var _tag2 = _interopRequireDefault(_tag);

var _tag3 = __webpack_require__(219);

var _tag4 = _interopRequireDefault(_tag3);

var _container = __webpack_require__(586);

var _container2 = _interopRequireDefault(_container);

var _container3 = __webpack_require__(535);

var _container4 = _interopRequireDefault(_container3);

var _tabPane = __webpack_require__(614);

var _tabPane2 = _interopRequireDefault(_tabPane);

var _tabPane3 = __webpack_require__(563);

var _tabPane4 = _interopRequireDefault(_tabPane3);

var _tabs = __webpack_require__(617);

var _tabs2 = _interopRequireDefault(_tabs);

var _tabs3 = __webpack_require__(566);

var _tabs4 = _interopRequireDefault(_tabs3);

var _tree = __webpack_require__(620);

var _tree2 = _interopRequireDefault(_tree);

var _tree3 = __webpack_require__(567);

var _tree4 = _interopRequireDefault(_tree3);

var _radioButton = __webpack_require__(605);

var _radioButton2 = _interopRequireDefault(_radioButton);

var _radioButton3 = __webpack_require__(555);

var _radioButton4 = _interopRequireDefault(_radioButton3);

var _radioGroup = __webpack_require__(606);

var _radioGroup2 = _interopRequireDefault(_radioGroup);

var _radioGroup3 = __webpack_require__(556);

var _radioGroup4 = _interopRequireDefault(_radioGroup3);

var _link = __webpack_require__(595);

var _link2 = _interopRequireDefault(_link);

var _link3 = __webpack_require__(543);

var _link4 = _interopRequireDefault(_link3);

var _radio = __webpack_require__(607);

var _radio2 = _interopRequireDefault(_radio);

var _radio3 = __webpack_require__(557);

var _radio4 = _interopRequireDefault(_radio3);

var _slider = __webpack_require__(610);

var _slider2 = _interopRequireDefault(_slider);

var _slider3 = __webpack_require__(559);

var _slider4 = _interopRequireDefault(_slider3);

var _backtop = __webpack_require__(575);

var _backtop2 = _interopRequireDefault(_backtop);

var _backtop3 = __webpack_require__(525);

var _backtop4 = _interopRequireDefault(_backtop3);

var _breadcrumbItem = __webpack_require__(577);

var _breadcrumbItem2 = _interopRequireDefault(_breadcrumbItem);

var _breadcrumbItem3 = __webpack_require__(526);

var _breadcrumbItem4 = _interopRequireDefault(_breadcrumbItem3);

var _breadcrumb = __webpack_require__(578);

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _breadcrumb3 = __webpack_require__(527);

var _breadcrumb4 = _interopRequireDefault(_breadcrumb3);

var _tooltip = __webpack_require__(619);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _tooltip3 = __webpack_require__(104);

var _tooltip4 = _interopRequireDefault(_tooltip3);

var _button = __webpack_require__(579);

var _button2 = _interopRequireDefault(_button);

var _base = __webpack_require__(576);

var _base2 = _interopRequireDefault(_base);

var _button3 = __webpack_require__(528);

var _button4 = _interopRequireDefault(_button3);

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(639);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(252);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(254);

var _store2 = _interopRequireDefault(_store);

var _vueLazyload = __webpack_require__(638);

var _vueLazyload2 = _interopRequireDefault(_vueLazyload);

var _vueInfiniteScroll = __webpack_require__(637);

var _vueInfiniteScroll2 = _interopRequireDefault(_vueInfiniteScroll);

var _vueCookie = __webpack_require__(636);

var _vueCookie2 = _interopRequireDefault(_vueCookie);

var _vueAwesomeSwiper = __webpack_require__(231);

var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);

var _vueContentPlaceholders = __webpack_require__(635);

var _vueContentPlaceholders2 = _interopRequireDefault(_vueContentPlaceholders);

__webpack_require__(153);

var _es6Promise = __webpack_require__(223);

var _es6Promise2 = _interopRequireDefault(_es6Promise);

var _zhTW = __webpack_require__(547);

var _zhTW2 = _interopRequireDefault(_zhTW);

var _locale = __webpack_require__(75);

var _locale2 = _interopRequireDefault(_locale);

var _vueSocialSharing = __webpack_require__(644);

var _vueSocialSharing2 = _interopRequireDefault(_vueSocialSharing);

var _vueMeta = __webpack_require__(641);

var _vueMeta2 = _interopRequireDefault(_vueMeta);

var _vueClipboard = __webpack_require__(634);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

__webpack_require__(588);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import VueAnalytics from 'vue-analytics'
// import VueGtag from 'vue-gtag'
// import VueGtm from '@gtm-support/vue2-gtm'
_vue2.default.use(_vueClipboard2.default);
// 设置语言
_locale2.default.use(_zhTW2.default);
__webpack_require__(223).polyfill();
_es6Promise2.default.polyfill();
_vue2.default.use(_vueAwesomeSwiper2.default);
_vue2.default.use(_vueContentPlaceholders2.default);
_vue2.default.use(_button4.default);
_vue2.default.use(_tooltip4.default);
_vue2.default.use(_breadcrumb4.default);
_vue2.default.use(_breadcrumbItem4.default);
_vue2.default.use(_vueMeta2.default, {
  refreshOnceOnNavigation: true
});
_vue2.default.use(_vueSocialSharing2.default);
_vue2.default.use(_backtop4.default);
_vue2.default.use(_slider4.default);
_vue2.default.use(_radio4.default);
_vue2.default.use(_link4.default);
_vue2.default.use(_radioGroup4.default);
_vue2.default.use(_radioButton4.default);
_vue2.default.use(_tree4.default);
_vue2.default.use(_tabs4.default);
_vue2.default.use(_tabPane4.default);
_vue2.default.use(_container4.default);
_vue2.default.use(_tag4.default);
_vue2.default.use(_main4.default);
_vue2.default.use(_header4.default);
_vue2.default.use(_aside4.default);
_vue2.default.use(_collapse4.default);
_vue2.default.use(_collapseItem4.default);
_vue2.default.use(_image4.default);
_vue2.default.use(_divider4.default);
_vue2.default.use(_pageHeader4.default);
_vue2.default.use(_row4.default);
_vue2.default.use(_col4.default);
_vue2.default.use(_drawer4.default);
_vue2.default.use(_carousel4.default);
_vue2.default.use(_carouselItem4.default);
_vue2.default.use(_menu4.default);
_vue2.default.use(_submenu4.default);
_vue2.default.use(_menuItem4.default);
_vue2.default.use(_pagination4.default);
_vue2.default.use(_checkbox4.default);
_vue2.default.use(_icon4.default);
_vue2.default.use(_autocomplete4.default);
_vue2.default.use(_steps4.default);
_vue2.default.use(_step4.default);
_vue2.default.use(_table4.default);
_vue2.default.use(_tableColumn4.default);
_vue2.default.use(_input4.default);
_vue2.default.use(_dialog4.default);
_vue2.default.use(_select4.default);
_vue2.default.use(_option4.default);
_vue2.default.use(_loading4.default.directive);
_vue2.default.prototype.$loading = _loading4.default.service;
_vue2.default.prototype.$notify = _notification4.default;
_vue2.default.prototype.$message = _message4.default;
_vue2.default.use(_vueInfiniteScroll2.default);
_vue2.default.use(_vueCookie2.default);
_vue2.default.use(_vueLazyload2.default, {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  loading: '/static/images/load.gif'
  // attempt: 1
});

// Vue.use(VueGtm, {
//   id: 'GTM-WB3RBJWX', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
//   queryParams: {
//     // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
//     gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
//     gtm_preview: 'env-4',
//     gtm_cookies_win: 'x'
//   },
//   defer: false,
//   compatibility: false,
//   nonce: '2726c7f26c',
//   enabled: true,
//   debug: true,
//   loadScript: true,
//   vueRouter: router,
//   ignoredViews: ['homepage'],
//   trackOnNextTick: false
// })

// Vue.use(VueGtag, {
//   config: {
//     id: 'G-YGM1SC33CD',
//     params: {
//       send_page_view: false
//     }
//   }
// }, router)
// Vue.use(VueAnalytics, {
//   id: 'UA-116844336-2',
//   router,
//   autoTracking: {
//     pageviewOnLoad: false
//   }
// })
_vue2.default.config.productionTip = false;
_router2.default.afterEach(function (to, from, next) {
  window.scrollTo(0, 0);
});
_router2.default.beforeEach(function (to, from, next) {
  if (to.meta.metaInfo) {
    _store2.default.commit('CHANGE_META_INFO', to.meta.metaInfo);
  }
  next();
});
/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  store: _store2.default,
  router: _router2.default,
  metaInfo: function metaInfo() {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [{
        vmid: 'title',
        name: 'title',
        content: this.$store.state.metaInfo.title
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$store.state.metaInfo.keywords
      }, {
        vmid: 'description',
        name: 'description',
        content: this.$store.state.metaInfo.description
      }, {
        vmid: 'imageogtag',
        property: 'og:image',
        content: this.$store.state.metaInfo.icon
      }, {
        vmid: 'urlogtag',
        property: 'og:url',
        content: this.$store.state.metaInfo.url
      }, {
        vmid: 'titleogtag',
        property: 'og:title',
        content: this.$store.state.metaInfo.title
      }, {
        vmid: 'descriptionogtag',
        property: 'og:description',
        content: this.$store.state.metaInfo.description
      }, {
        vmid: 'twitter:card',
        name: 'twitter:card',
        content: 'summary'
      }, {
        name: 'twitter:description',
        vmid: 'twitter:description',
        content: this.$store.state.metaInfo.description
      }, {
        name: 'twitter:title',
        vmid: 'twitter:title',
        content: this.$store.state.metaInfo.title
      }, {
        vmid: 'twitter:image',
        name: 'twitter:image',
        content: this.$store.state.metaInfo.icon
      }]
    };
  },

  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.search = exports.playlist = exports.dianboOrder = exports.dianbo = exports.report = exports.baoenQueryList = exports.baoentreeQueryAll = exports.baoentreeQuery = exports.baoentree = exports.indexFirstlist = exports.specialsubtables = exports.zhiboIndexSG = exports.getzhibolist = exports.zhiboIndex = undefined;

var _public = __webpack_require__(163);

var _public2 = _interopRequireDefault(_public);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 首页最新讯息
var zhiboIndex = exports.zhiboIndex = function zhiboIndex(params) {
  if (typeof params.url === 'undefined') {
    return _public2.default.fetchGet('/v2/live/livetv', null);
  } else {
    return _public2.default.fetchGet('/v2/live/livetv/' + params.url, null);
  }
};
// 时间变化是获取直播列表
var getzhibolist = exports.getzhibolist = function getzhibolist(params) {
  return _public2.default.fetchGet('/v2/live/livetv?startDate=' + params);
};
var zhiboIndexSG = exports.zhiboIndexSG = function zhiboIndexSG(params) {
  return _public2.default.fetchGet('/v2/live/livetv/sg', params);
};
var specialsubtables = exports.specialsubtables = function specialsubtables(params) {
  return _public2.default.fetchGet('/v2/specialsubtables?per_page = 6', params);
};
var indexFirstlist = exports.indexFirstlist = function indexFirstlist(params) {
  return _public2.default.fetchGet('/v2/newcategory?scope=amtb&filter=topspeechhome&limit=6', params);
};
var baoentree = exports.baoentree = function baoentree(params) {
  return _public2.default.fetchGet('/v2/newcategory?scope=amtb&hotspeechlimit=10', params);
};
var baoentreeQuery = exports.baoentreeQuery = function baoentreeQuery(params) {
  var url = '/v2/newcategory';
  params.paramer.forEach(function (item, index, arr) {
    url = url + '/' + item;
  });
  url = url + '?scope=amtb&sort_type=' + params.type + '&sort_column=' + params.column + '&page=' + params.page + '&per_page=' + params.pagenum;
  return _public2.default.fetchGet(url);
};
var baoentreeQueryAll = exports.baoentreeQueryAll = function baoentreeQueryAll(params) {
  var url = '/v2/newcategorysearch';
  params.paramer.forEach(function (item, index, arr) {
    url = url + '/' + item;
  });
  url = url + '?scope=amtb&sort_type=' + params.type + '&sort_column=' + params.column + '&page=' + params.page + '&per_page=' + params.pagenum;
  return _public2.default.fetchGet(url);
};
var baoenQueryList = exports.baoenQueryList = function baoenQueryList(params) {
  var url = '/v2/baen/';
  params.forEach(function (item, index, arr) {
    url = url + '/' + item;
  });
  return _public2.default.fetchGet(url);
};
var report = exports.report = function report(params) {
  return _public2.default.fetchPost('/report', params);
};
var dianbo = exports.dianbo = function dianbo(params) {
  var url = '/v2/medias';
  params.forEach(function (item, index, arr) {
    url = url + '/' + item;
  });
  return _public2.default.fetchGet(url, null);
};
var dianboOrder = exports.dianboOrder = function dianboOrder(params, sortType) {
  var url = '/v2/medias';
  params.forEach(function (item, index, arr) {
    url = url + '/' + item;
  });
  url = url + '?sort_type=' + sortType;
  return _public2.default.fetchGet(url, null);
};
var playlist = exports.playlist = function playlist(params) {
  var url = '/v2/playlist?src=' + params;
  return _public2.default.fetchGet(url, null);
};
var search = exports.search = function search(params) {
  var url = '/search';
  return _public2.default.fetchPost(url, params);
};

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardIndexNew = exports.cardDownNew = exports.cardPageNew = exports.blogmedia = exports.imgIndex = exports.blog = exports.mb = exports.mbcategory = exports.pdfdown = exports.cardIndex = exports.cardDown = exports.cardPage = exports.ebookIndex = exports.ebookPage = exports.enlightList = exports.enlightPage = exports.enlightIndex = exports.rsfs = undefined;

var _public = __webpack_require__(163);

var _public2 = _interopRequireDefault(_public);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rsfs = exports.rsfs = function rsfs(params) {
  // 认识师父类别树
  return _public2.default.fetchGet('/api/comprehendList.action', params);
};
var enlightIndex = exports.enlightIndex = function enlightIndex(params) {
  return _public2.default.fetchGet('/api/enlighttalkList.action', { params: params });
};
var enlightPage = exports.enlightPage = function enlightPage(params) {
  return _public2.default.fetchGet('/api/enlighttalkPage.action', { params: params });
};
var enlightList = exports.enlightList = function enlightList(params) {
  return _public2.default.fetchGet('/api/queryEnlightTalkList.action', { params: params });
};
var ebookPage = exports.ebookPage = function ebookPage(params) {
  // 电子书最新推荐
  return _public2.default.fetchGet('/api/ebookPage.action', { params: params });
};
var ebookIndex = exports.ebookIndex = function ebookIndex(params) {
  // 电子书最新推荐
  return _public2.default.fetchGet('/api/ebookIndex.action', { params: params });
};
var cardPage = exports.cardPage = function cardPage(params) {
  // 电子书最新推荐
  return _public2.default.fetchGet('/api/cardPage.action', { params: params });
};
var cardDown = exports.cardDown = function cardDown(params) {
  return _public2.default.fetchGet('/api/cardDown.action', { params: params });
};
var cardIndex = exports.cardIndex = function cardIndex(params) {
  // 电子书最新推荐
  return _public2.default.fetchGet('/api/cardIndex.action', { params: params });
};
var pdfdown = exports.pdfdown = function pdfdown(url) {
  // 电子书下载
  return _public2.default.fetchGet(url, {
    responseType: 'arraybuffer'
  });
};
var mbcategory = exports.mbcategory = function mbcategory(params) {
  // 墨宝类别
  var url = '/v2/mb';
  return _public2.default.fetchGet(url);
};
var mb = exports.mb = function mb(params) {
  // 墨宝列表接口
  var url = '/v2/mb/' + params.category + '?page=' + params.page + '&per_page=' + params.per_page;
  return _public2.default.fetchGet(url);
};
// export const blog = (params) => {
//   // blog接口
//   return http.fetchGet('/blogs/posts?categories=70&per_page=5&page=1', params)
// }
// export const imgIndex = (params) => {
//   // blog接口
//   return http.fetchGet('/blogs/posts?categories=1&per_page=4&page=1&orderby=date', params)
// }
// export const blogmedia = (params, mediaId) => {
//   // blog接口
//   return http.fetchGet('/media/' + mediaId, params)
// }
var blog = exports.blog = function blog(params) {
  // blog接口
  return _public2.default.fetchGet('/blog/wp-json/wp/v2/posts?categories=70&per_page=5&page=1', params);
};
var imgIndex = exports.imgIndex = function imgIndex(params) {
  // blog接口
  return _public2.default.fetchGet('/blog/wp-json/wp/v2/posts?categories=1&per_page=4&page=1&orderby=date', params);
};
var blogmedia = exports.blogmedia = function blogmedia(params, mediaId) {
  // blog接口
  return _public2.default.fetchGet('/blog/wp-json/wp/v2/media/' + mediaId, params);
};

var cardPageNew = exports.cardPageNew = function cardPageNew(params) {
  //  获取卡片
  return _public2.default.fetchPost('/fashuichangliu/card/list', params);
};
var cardDownNew = exports.cardDownNew = function cardDownNew(cardId) {
  // 下载卡片 更新下载次数
  return _public2.default.fetchPut('/fashuichangliu/card/' + cardId);
};
var cardIndexNew = exports.cardIndexNew = function cardIndexNew(params) {
  //  获取卡片目录
  return _public2.default.fetchPost('/fashuichangliu/card/type', params);
};

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(643);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Index = function Index() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 664));
};
var Zhibo = function Zhibo() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 660));
};
var Lectureroom = function Lectureroom() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 657));
};
var Videoplay = function Videoplay() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 659));
};
var Index2 = function Index2() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 652));
};
var NewMessage = function NewMessage() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 653));
};
var Jinghua = function Jinghua() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 655));
};
var Understand = function Understand() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 656));
};
var Ebook = function Ebook() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 663));
};
var EbookList = function EbookList() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 662));
};
var BookInfo = function BookInfo() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 661));
};
var MoIndex = function MoIndex() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 667));
};
var DeskIndex = function DeskIndex() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 665));
};
var DeskIndexnew = function DeskIndexnew() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 666));
};
var Sharepage = function Sharepage() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 658));
};
var Privacy = function Privacy() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 654));
};

_vue2.default.use(_vueRouter2.default);
exports.default = new _vueRouter2.default({
  routes: [{
    path: '/',
    component: Index,
    name: 'index',
    redirect: '/home',
    children: [{ path: 'home',
      name: 'home',
      component: Index2,
      meta: {
        metaInfo: {
          title: '淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'livetv',
      name: 'livetv',
      component: Zhibo,
      meta: {
        metaInfo: {
          title: '直播台｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網直播台24小時全天直播',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      }
    }, { path: 'videoplay',
      name: 'videoplay',
      component: Videoplay,
      meta: {
        metaInfo: {
          title: '视频点播｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網视频点播',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'understand',
      name: 'understand',
      component: Understand,
      meta: {
        metaInfo: {
          title: '認識法師｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網認識法師',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'newMessage',
      name: 'newMessage',
      component: NewMessage,
      meta: {
        metaInfo: {
          title: '直播台｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網直播台24小時全天直播',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'jinghua',
      name: 'jinghua',
      component: Jinghua,
      meta: {
        metaInfo: {
          title: '菁華開示｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網菁華開示',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'ebook',
      name: 'ebook',
      component: Ebook,
      meta: {
        metaInfo: {
          title: '講記著作｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網電子書',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'ebooklist',
      name: 'ebooklist',
      component: EbookList,
      meta: {
        metaInfo: {
          title: '講記著作｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網電子書',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'bookInfo',
      name: 'bookInfo',
      component: BookInfo,
      meta: {
        metaInfo: {
          title: '講記著作｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網電子書',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'moIndex',
      name: 'moIndex',
      component: MoIndex,
      meta: {
        metaInfo: {
          title: '墨寶｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網墨寶',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'deskIndexold',
      name: 'deskIndexold',
      component: DeskIndex,
      meta: {
        metaInfo: {
          title: '卡片｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網卡片',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'deskIndex',
      name: 'deskIndex',
      component: DeskIndexnew,
      meta: {
        metaInfo: {
          title: '卡片｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網卡片',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      } }, { path: 'lectureroom',
      name: 'lectureroom',
      component: Lectureroom,
      meta: {
        metaInfo: {
          title: '報恩講堂｜淨空老法師專集網',
          keywords: '淨空老法師,無量壽經',
          description: '淨空老法師專集網報恩講堂',
          icon: '/static/images/unesco_mjk.jpg',
          url: window.location.href
        }
      }
    }, { path: '/privacy', name: 'privacy', component: Privacy }]
  }, { path: '/sharepage', name: 'sharepage', component: Sharepage }, { path: '*', redirect: '/home' }]
});

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(227);

var _vuex2 = _interopRequireDefault(_vuex);

var _mutations = __webpack_require__(256);

var _mutations2 = _interopRequireDefault(_mutations);

var _action = __webpack_require__(253);

var _action2 = _interopRequireDefault(_action);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
  metaInfo: {
    title: '',
    keywords: '',
    icon: '/static/images/unesco_mjk.jpg',
    url: '',
    description: ''
  },
  mobaoCategory: [], // 墨寶類別list
  mobaoCategoryLoading: false, // 墨寶類別loading
  mobaoList: [], // 墨寶list
  mobaoListLoading: false, // 墨寶listloading
  wallcardCategory: [], // 卡片類別list
  wallcardCategoryLoading: false, // 卡片類別loading
  wallcardList: [], // 卡片list
  wallcardListLoading: false, // 卡片listloading
  preMobaoArray: [], // 墨宝预览
  channelinfo: {}, // 直播信息
  playerConfig: {}, // 直播播放器配置
  liveContent: {}, // 直播信息文字
  bestServerInfo: {}, // 直播最佳服务器
  flushtime: 1000, // 下一次刷新时间
  zhiboReady: false, // 直播数据请求完备
  newMessageLoading: true, // 最新资讯是否加载完毕
  newMessageList: [], // 最新资讯列表
  baoenQueryList: [], // 报恩讲堂查询列表
  baoenQueryListSize: 0, // 报恩讲堂查询列表
  topspeech: {}, // 最新资讯列表
  topspeechShow: true, // 最新资讯列表是否显示，否则显示点击树后查询到的
  baoenTree: { code: 1, category: { AMTB_NAME: '最近更新' } }, // 报恩讲堂目录树
  baoenCategoryList: {}, // 點擊樹後查詢的列表
  playlistindex: 0, // 播放的集数
  indexFirstList: [], // 首页最新讲演
  indexFirstLoading: true, // 最新讲演是否加载完毕
  dianboLoading: true, // 最新讲演是否加载完毕
  dianboplayerConfig: {}, // 最新讲演是否加载完毕
  dianbodoc: {}, // 点播doc
  subtable: {}, // 点播信息
  specialtopicList: {}, // 点播信息
  countryCode: '0', // 国家代码
  queryloading: false, // 查询loading
  dianbobestserverinfo: {}, // 点播doc
  docAllHits: 0, // 點播播放量
  mp4list: [], // 点播doc
  mp3list: [], // 点播doc
  mp4total: 0, // 总集数
  mp3total: 0, // 总集数
  aid: 0, // 一天有效id
  hid: 0, // 长时间有效用户id
  preUrl: '', // 长时间有效用户id
  recentspeech: [], // 长时间有效用户id
  hotspeech: [], // 长时间有效用户id
  zhibocountry: 'cn', // 直播的地区代码
  dianbocountry: 'cn', // 点播的地区代码
  jiangtangInfo: {}, // 点播的总信息
  indexbottom: [], // 首页底部的图片
  baoenloading: true, // 首页底部的图片
  indexbottomLoading: true, // 首页底部的图片加载
  fsInfoLoading: false,
  rsfsTypeList: [],
  rsfsList: [],
  rsfsTypes: [],
  rsfsObject: { menuName: '', nemuContent: '', id: 0, type: 1 },
  enlightTypes: [],
  enlightPage: { begin: 0, countItem: 0, nextPage: 0, pageCount: 0, pageNo: 1, pageSize: 10, rows: [] },
  enlightObject: { menuName: '', nemuContent: '', id: 0, type: 1 },
  enlightLoading: true, // 菁華開示總loading
  enlightInfoLoading: false, // 菁華詳細
  ebookTreeLoading: true,
  ebookTypes: [],
  ebookTops: [],
  ebookPage: { begin: 0, countItem: 0, nextPage: 0, pageCount: 0, pageNo: 1, pageSize: 10, rows: [] },
  cardTypes: [],
  cardPage: { begin: 0, countItem: 0, nextPage: 0, pageCount: 0, pageNo: 1, pageSize: 10, rows: [] },
  mediaData: {}, // videojs所需要的数据
  ftpstatement: '' // ftp声明
};

exports.default = new _vuex2.default.Store({
  state: state,
  action: _action2.default,
  mutations: _mutations2.default
});

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT_BUYCART = exports.INIT_BUYCART = 'INIT_BUYCART';
var CHANGE_META_INFO = exports.CHANGE_META_INFO = 'CHANGE_META_INFO';
var INDEX_FIRSTLIST = exports.INDEX_FIRSTLIST = 'INDEX_FIRSTLIST';
var INIT_NEWMESSAGELIST = exports.INIT_NEWMESSAGELIST = 'INIT_NEWMESSAGELIST';
var INIT_ZHIBO = exports.INIT_ZHIBO = 'INIT_ZHIBO';
var RE_ZHIBO = exports.RE_ZHIBO = 'RE_ZHIBO';
var DES_ZHIBO = exports.DES_ZHIBO = 'DES_ZHIBO';
var INIT_BAOEN_TREE = exports.INIT_BAOEN_TREE = 'INIT_BAOEN_TREE';
var DES_BAOEN_TREE = exports.DES_BAOEN_TREE = 'DES_BAOEN_TREE';
var SET_COUNTRYCODE = exports.SET_COUNTRYCODE = 'SET_COUNTRYCODE';
var GET_BAOEN_LIST = exports.GET_BAOEN_LIST = 'GET_BAOEN_LIST';
var QUERY_BAOEN_LIST = exports.QUERY_BAOEN_LIST = 'QUERY_BAOEN_LIST';
var QUERY_BAOEN_ALL_LIST = exports.QUERY_BAOEN_ALL_LIST = 'QUERY_BAOEN_ALL_LIST';
var PAGECHANGE = exports.PAGECHANGE = 'PAGECHANGE';
var RELOADVIDEO = exports.RELOADVIDEO = 'RELOADVIDEO';
var ADD_CART = exports.ADD_CART = 'ADD_CART';
var GET_USERINFO = exports.GET_USERINFO = 'GET_USERINFO';
var RECORD_USERINFO = exports.RECORD_USERINFO = 'RECORD_USERINFO';
var ADD_ANIMATION = exports.ADD_ANIMATION = 'ADD_ANIMATION';
var SHOW_CART = exports.SHOW_CART = 'SHOW_CART';
var REDUCE_CART = exports.REDUCE_CART = 'REDUCE_CART';
var EDIT_CART = exports.EDIT_CART = 'EDIT_CART';
var INIT_PLAYER = exports.INIT_PLAYER = 'INIT_PLAYER';
var DES_PLAYER = exports.DES_PLAYER = 'DES_PLAYER';
var INIT_PLAYER_MP3 = exports.INIT_PLAYER_MP3 = 'INIT_PLAYER_MP3';
var PLAYER_NEXT_SECTION = exports.PLAYER_NEXT_SECTION = 'PLAYER_NEXT_SECTION';
var ENLIGHT_LIST = exports.ENLIGHT_LIST = 'ENLIGHT_LIST';
var ENLIGHT_LIST_OPEN = exports.ENLIGHT_LIST_OPEN = 'ENLIGHT_LIST_OPEN';
var ENLIGHT_LOADING = exports.ENLIGHT_LOADING = 'ENLIGHT_LOADING';
var ENLIGHT_INFO = exports.ENLIGHT_INFO = 'ENLIGHT_INFO';
var ENLIGHT_INFO_LOADING = exports.ENLIGHT_INFO_LOADING = 'ENLIGHT_INFO_LOADING';
var FS_RIGHT_INFO_LOADING = exports.FS_RIGHT_INFO_LOADING = 'FS_RIGHT_INFO_LOADING';
var MOBAO_CATEGORY = exports.MOBAO_CATEGORY = 'MOBAO_CATEGORY';
var MOBAO_CATEGORY_LOADING = exports.MOBAO_CATEGORY_LOADING = 'MOBAO_CATEGORY_LOADING';
var MOBAO_LIST = exports.MOBAO_LIST = 'MOBAO_LIST';
var MOBAO_LIST_LOADING = exports.MOBAO_LIST_LOADING = 'MOBAO_LIST_LOADING';
var MOBAO_CATEGORY_CHANCE = exports.MOBAO_CATEGORY_CHANCE = 'MOBAO_CATEGORY_CHANCE';
var IMG_INDEX = exports.IMG_INDEX = 'IMG_INDEX';
var EBOOK_SEARCH = exports.EBOOK_SEARCH = 'EBOOK_SEARCH';
var RSFS_INDEX2 = exports.RSFS_INDEX2 = 'RSFS_INDEX2';
var RSFS_TYPELIST = exports.RSFS_TYPELIST = 'RSFS_TYPELIST';
var RSFS_INFO = exports.RSFS_INFO = 'RSFS_INFO';
var RSFS_EXINFO = exports.RSFS_EXINFO = 'RSFS_EXINFO';
var ENLIGHT_INDEX = exports.ENLIGHT_INDEX = 'ENLIGHT_INDEX';
var ENLIGHT_PAGE = exports.ENLIGHT_PAGE = 'ENLIGHT_PAGE';
var QUERY_ENLIGHT_LIST = exports.QUERY_ENLIGHT_LIST = 'QUERY_ENLIGHT_LIST';
var EBOOK_PAGE = exports.EBOOK_PAGE = 'EBOOK_PAGE';
var EBOOK_INDEX = exports.EBOOK_INDEX = 'EBOOK_INDEX';
var EBOOK_TREE_LOADING = exports.EBOOK_TREE_LOADING = 'EBOOK_TREE_LOADING';
var CARD_INDEX = exports.CARD_INDEX = 'CARD_INDEX';
var CARD_PAGE = exports.CARD_PAGE = 'CARD_PAGE';
var CARD_DOWN = exports.CARD_DOWN = 'CARD_DOWN';
var CARD_INDEX_NEW = exports.CARD_INDEX_NEW = 'CARD_INDEX_NEW';
var CARD_PAGE_NEW = exports.CARD_PAGE_NEW = 'CARD_PAGE_NEW';
var CARD_DOWN_NEW = exports.CARD_DOWN_NEW = 'CARD_DOWN_NEW';
var WALLCARD_LIST_LOADING = exports.WALLCARD_LIST_LOADING = 'WALLCARD_LIST_LOADING';
var INIT_PLAYER_ORDER = exports.INIT_PLAYER_ORDER = 'INIT_PLAYER_ORDER';
var INIT_PLAYER_MP3_ORDER = exports.INIT_PLAYER_MP3_ORDER = 'INIT_PLAYER_MP3_ORDER';
var CHANGE_ZHIBO_LIST = exports.CHANGE_ZHIBO_LIST = 'CHANGE_ZHIBO_LIST';

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(167);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(157);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(154);

var _assign2 = _interopRequireDefault(_assign);

var _CHANGE_META_INFO$INI;

var _mutationTypes = __webpack_require__(255);

var _storage = __webpack_require__(257);

var _index = __webpack_require__(251);

var _zhibo = __webpack_require__(230);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_CHANGE_META_INFO$INI = {}, (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.CHANGE_META_INFO, function (state, metaInfo) {
  state.metaInfo = metaInfo;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.INIT_NEWMESSAGELIST, function (state) {
  var data = (0, _assign2.default)({}, {
    categories: 70,
    per_page: 6,
    page: 1
  });
  (0, _index.blog)(data).then(function (res) {
    console.log('blog:%o', res);
    state.newMessageList = res;
    state.newMessageLoading = false;
  }, function (res) {});
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.INIT_ZHIBO, function (state, data) {
  (0, _zhibo.zhiboIndex)(data).then(function (res) {
    if (res.code === 0) {
      var s = {
        src: res.channelinfo.videoHlsUrl,
        type: 'application/x-mpegurl',
        live: true
      };
      var sourceArray = [s];
      console.log('源數組大小%s', sourceArray.length);
      state.playerConfig = {
        ratio: 9 / 16,
        autoplay: false,
        debug: false,
        share: false,
        chromecast: false,
        // analytics: 'UA-116844336-2',
        poster: res.channelinfo.poster,
        clip: {
          sources: sourceArray
        }
      };
      state.zhiboReady = true;
      state.channelinfo = res.channelinfo;
      state.liveContent = res.channelinfo.liveContent;
      state.bestServerInfo = res.channelinfo.bestServerInfo;
      var curr = res.channelinfo.currentPlaylist;
      state.flushtime = curr.flushtime;
      state.zhibocountry = res.channelinfo.country;
      if ((0, _storage.getStore)('hid') == null) {
        var uuid = (0, _storage.genUUID)(5);
        (0, _storage.setStore)('hid', uuid);
        state.hid = uuid;
      } else {
        state.hid = (0, _storage.getStore)('hid');
      }
      if ((0, _storage.getStore)('aid') == null) {
        var uuid2 = Date.now();
        (0, _storage.setStore)('hid', uuid2);
        state.aid = uuid2;
      } else {
        state.aid = (0, _storage.getStore)('aid');
      }
    } else {
      state.channelinfo = null;
      state.zhiboReady = false;
      state.flushtime = 1500;
    }
  }, function (res) {});
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.CHANGE_ZHIBO_LIST, function (state, data) {
  (0, _zhibo.getzhibolist)(data).then(function (res) {
    if (res.code === 0) {
      var s = {
        src: res.channelinfo.videoHlsUrl,
        type: 'application/x-mpegurl',
        live: true
      };
      var sourceArray = [s];
      console.log('源數組大小%s', sourceArray.length);
      state.playerConfig = {
        ratio: 9 / 16,
        autoplay: false,
        debug: false,
        share: false,
        chromecast: false,
        // analytics: 'UA-116844336-2',
        clip: {
          sources: sourceArray
        }
      };
      state.zhiboReady = true;
      state.channelinfo = res.channelinfo;
      state.liveContent = res.channelinfo.liveContent;
      state.bestServerInfo = res.channelinfo.bestServerInfo;
      var curr = res.channelinfo.currentPlaylist;
      state.flushtime = curr.flushtime;
      state.zhibocountry = res.channelinfo.country;
      if ((0, _storage.getStore)('hid') == null) {
        var uuid = (0, _storage.genUUID)(5);
        (0, _storage.setStore)('hid', uuid);
        state.hid = uuid;
      } else {
        state.hid = (0, _storage.getStore)('hid');
      }
      if ((0, _storage.getStore)('aid') == null) {
        var uuid2 = Date.now();
        (0, _storage.setStore)('hid', uuid2);
        state.aid = uuid2;
      } else {
        state.aid = (0, _storage.getStore)('aid');
      }
    } else {
      state.channelinfo = null;
      state.zhiboReady = false;
      state.flushtime = 1500;
    }
  }, function (res) {});
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.RE_ZHIBO, function (state, data) {
  (0, _zhibo.zhiboIndex)(data).then(function (res) {
    if (res.code === 0) {
      state.channelinfo = res.channelinfo;
      state.liveContent = res.channelinfo.liveContent;
      state.bestServerInfo = res.channelinfo.bestServerInfo;
      var curr = res.channelinfo.currentPlaylist;
      state.flushtime = curr.flushtime;
    } else {
      state.channelinfo = null;
      state.zhiboReady = false;
      state.flushtime = 1500;
    }
  }, function (res) {});
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.INIT_BAOEN_TREE, function (state) {
  (0, _zhibo.baoentree)().then(function (res) {
    if (res.code === 0) {
      state.preUrl = res.speechposterUrl;
      state.baoenTree = res.categories[0];
      state.topspeech = res.topspeech;
      state.recentspeech = res.recentspeech;
      state.hotspeech = res.hotspeech.data;
      state.ftpstatement = res.ftpstatement;
    } else {}
  }, function (res) {});
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.INDEX_FIRSTLIST, function (state) {
  (0, _zhibo.specialsubtables)().then(function (res) {
    if (res.code === 0) {
      state.specialtopicList = res.sutables.data;
      state.specialtopicList.push({ 'type': 1, 'title': '講演節錄', 'url': 'https://www.amtb.tw/#/lectureroom?categoryid=43' });
    } else {
      state.indexFirstLoading = true;
    }
  }, function (res) {});
  (0, _zhibo.indexFirstlist)().then(function (res) {
    if (res.code === 0) {
      state.indexFirstList = res.topspeechhome.data;
      state.indexFirstLoading = false;
    } else {
      state.indexFirstLoading = true;
    }
  }, function (res) {});
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.GET_BAOEN_LIST, function (state, paramer) {
  state.baoenloading = true;
  state.baoenTree.code = 1;
  (0, _zhibo.baoentreeQuery)(paramer).then(function (res) {
    if (res.code === 0) {
      state.baoenloading = false;
      state.baoenTree.code = 0;
      state.baoenTree.category = res.category;
      state.baoenCategoryList = res.sutables;
      state.topspeechShow = false;
    } else {}
  }, function (res) {});
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.QUERY_BAOEN_LIST, function (state, paramer) {
  state.queryloading = true;
  (0, _zhibo.baoentreeQuery)(paramer).then(function (res) {
    if (res.code === 0) {
      state.baoenQueryList = res.sutables.data;
      state.queryloading = false;
    } else {}
  }, function (res) {});
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.QUERY_BAOEN_ALL_LIST, function (state, paramer) {
  state.queryloading = true;
  (0, _zhibo.baoentreeQueryAll)(paramer).then(function (res) {
    if (res.code === 0) {
      state.baoenQueryList = res.sutables.data;
      state.baoenQueryListSize = res.sutables.total;
      state.queryloading = false;
    } else {}
  }, function (res) {});
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.INIT_PLAYER, function (state, paramer) {
  (0, _zhibo.dianbo)(paramer).then(function (res) {
    if (res.code === 0) {
      state.mediaData = res;
      state.jiangtangInfo = res.jiangtanginfo;
      state.dianbobestserverinfo = res.bestserverinfo;
      state.dianbodoc = res.jiangtanginfo.doc;
      state.docAllHits = res.jiangtanginfo.doc.all_hits;
      state.playlistindex = res.jiangtanginfo.playlistindex;
      var playlistindex = res.jiangtanginfo.playlistindex;
      state.subtable = res.jiangtanginfo.subtable;
      var host = res.bestserverinfo.domain;
      var list = res.jiangtanginfo.mp4list;
      var list2 = res.jiangtanginfo.mp3list;
      state.mp4total = list.length;
      state.mp3total = list2.length;
      var sourceList = [];
      var mp4list = [];
      var mp3list = [];
      var url = 'https://' + res.bestserverinfo.domain;
      list.forEach(function (item, index) {
        var mp4Item = { name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, number: item.id, poster: item.poster, index: index, title: item.title, item: item, downurl: url + item.fileHttpUrl };
        if (playlistindex === index) {
          mp4Item.isplay = true;
        } else {
          mp4Item.isplay = false;
        }
        mp4list.push(mp4Item);
      });
      list2.forEach(function (item, index) {
        var mp3Item = { name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl };
        if (playlistindex === index) {
          mp3Item.isplay = true;
        } else {
          mp3Item.isplay = false;
        }
        mp3list.push(mp3Item);
      });
      state.mp4list = mp4list;
      state.mp3list = mp3list;
      // state.mp4total = list.length
      // state.mp3total = list2.length
      list.forEach(function (item) {
        var s1 = {
          type: 'application/x-mpegurl',
          src: 'https://' + host + item.fileHlsUrl
        };
        var s2 = {
          type: 'video/mp4',
          src: 'https://' + host + item.fileHttpUrl
        };
        var sourceArray = [s1, s2];
        var sourceItem = { sources: sourceArray };
        sourceList.push(sourceItem);
        state.dianboplayerConfig = {
          ratio: 9 / 16,
          autoplay: false,
          debug: false,
          share: true,
          facebook: true,
          chromecast: true,
          // analytics: 'UA-116844336-2',
          playlist: sourceList,
          hlsjs: {
            safari: false,
            recoverMediaError: true,
            recoverNetworkError: true
          }
        };
        state.dianboLoading = false;
        state.countryCode = res.jiangtanginfo.autocode;
        state.dianbocountry = res.jiangtanginfo.autocode;
        if ((0, _storage.getStore)('hid') == null) {
          var uuid = (0, _storage.genUUID)(5);
          (0, _storage.setStore)('hid', uuid);
          state.hid = uuid;
        } else {
          state.hid = (0, _storage.getStore)('hid');
        }
        if ((0, _storage.getStore)('aid') == null) {
          var uuid2 = Date.now();
          (0, _storage.setStore)('hid', uuid2);
          state.aid = uuid2;
        } else {
          state.aid = (0, _storage.getStore)('aid');
        }
      });
    } else {
      console.log('dianbo shibao');
    }
  }, function (res) {
    console.log('dianbo shibao');
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.PLAYER_NEXT_SECTION, function (state, paramer) {
  (0, _zhibo.playlist)(paramer.video).then(function (res) {
    if (res.code === 0) {
      state.dianbodoc = res.doc;
      state.docAllHits = res.doc.all_hits;
      state.playlistindex = paramer.index;
    } else {
      console.log('dianbo shibao');
    }
  }, function (res) {
    console.log('dianbo shibao');
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.INIT_PLAYER_MP3, function (state, paramer) {
  (0, _zhibo.dianbo)(paramer).then(function (res) {
    if (res.code === 0) {
      console.log('dianbo chenggong');
      state.mediaData = res;
      state.jiangtangInfo = res.jiangtanginfo;
      state.dianbobestserverinfo = res.bestserverinfo;
      state.dianbodoc = res.jiangtanginfo.doc;
      state.docAllHits = res.jiangtanginfo.doc.all_hits;
      state.playlistindex = res.jiangtanginfo.playlistindex;
      var playlistindex = res.jiangtanginfo.playlistindex;
      state.subtable = res.jiangtanginfo.subtable;
      var host = res.bestserverinfo.domain;
      var list = res.jiangtanginfo.mp4list;
      var list2 = res.jiangtanginfo.mp3list;
      state.mp4total = list.length;
      state.mp3total = list2.length;
      var sourceList = [];
      var mp4list = [];
      var mp3list = [];
      var url = 'https://' + res.bestserverinfo.domain;
      list.forEach(function (item, index) {
        var mp4Item = { name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, index: index, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl };
        if (playlistindex === index) {
          mp4Item.isplay = true;
        } else {
          mp4Item.isplay = false;
        }
        mp4list.push(mp4Item);
      });
      list2.forEach(function (item, index) {
        var mp3Item = { name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, index: index, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl };
        if (playlistindex === index) {
          mp3list.isplay = true;
        } else {
          mp3list.isplay = false;
        }
        mp3list.push(mp3Item);
      });
      state.mp4list = mp4list;
      state.mp3list = mp3list;
      // state.mp4total = list.length
      // state.mp3total = list2.length
      list2.forEach(function (item) {
        var s2 = {
          type: 'audio/mpeg',
          src: 'https://' + host + item.fileHttpUrl
        };
        var sourceArray = [s2];
        var sourceItem = { audio: true, coverImage: item.poster, sources: sourceArray };
        sourceList.push(sourceItem);
      });
      state.dianboplayerConfig = {
        ratio: 9 / 16,
        autoplay: false,
        debug: false,
        share: true,
        facebook: true,
        chromecast: false,
        // analytics: 'UA-116844336-2',
        playlist: sourceList,
        hlsjs: {
          safari: false,
          recoverMediaError: true,
          recoverNetworkError: true
        }
      };
      state.dianboLoading = false;
      state.dianbocountry = res.jiangtanginfo.autocode;
      if ((0, _storage.getStore)('hid') == null) {
        var uuid = (0, _storage.genUUID)(5);
        (0, _storage.setStore)('hid', uuid);
        state.hid = uuid;
      } else {
        state.hid = (0, _storage.getStore)('hid');
      }
      if ((0, _storage.getStore)('aid') == null) {
        var uuid2 = Date.now();
        (0, _storage.setStore)('hid', uuid2);
        state.aid = uuid2;
      } else {
        state.aid = (0, _storage.getStore)('aid');
      }
    } else {
      console.log('dianbo fail');
    }
  }, function (res) {
    console.log('dianbo fail');
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.PAGECHANGE, function (state, page) {
  page = page - 1;
  var list = state.jiangtangInfo.mp4list;
  var list2 = state.jiangtangInfo.mp3list;
  var mp4list = [];
  var mp3list = [];
  var url = 'https://' + state.dianbobestserverinfo.domain;
  var i = 0;
  var j = 0;
  list.forEach(function (item, index) {
    if (page * 15 <= index && i < 15) {
      i++;
      var mp4Item = { name: item.titleshow, title: item.title, item: item, downurl: url + item.fileHttpUrl };
      mp4list.push(mp4Item);
    }
  });
  list2.forEach(function (item, index) {
    if (page * 15 <= index && j < 15) {
      j++;
      var mp3Item = { name: item.titleshow, title: item.title, item: item, downurl: url + item.fileHttpUrl };
      mp3list.push(mp3Item);
    }
  });
  state.mp4list = mp4list;
  state.mp3list = mp3list;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.RELOADVIDEO, function (state) {
  state.dianboLoading = true;
  state.dianbodoc.jingwencontent = '';
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.DES_PLAYER, function (state) {
  state.dianboLoading = true;
  state.dianbodoc = { jingwencontent: '' };
  state.countryCode = '0';
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.DES_ZHIBO, function (state) {
  state.zhiboReady = false;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.DES_BAOEN_TREE, function (state) {
  state.topspeechShow = true;
  state.baoenQueryList = [];
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.SET_COUNTRYCODE, function (state, paramer) {
  state.countryCode = paramer;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.MOBAO_CATEGORY, function (state, param) {
  var imgArray = [{ src: 'fayu_t.png', src2: 'fayu_tred.png' }, { src: 'shuming_t.png', src2: 'shuming_tred.png' }, { src: 'daochang_t.png', src2: 'daochang_tred.png' }, { src: 'fashi_t.png', src2: 'fashi_tred.png' }, { src: 'duiju_t.png', src2: 'duiju_tred.png' }, { src: 'duanju_t.png', src2: 'duanju_tred.png' }, { src: 'yuanxing_t.png', src2: 'yuanxing_tred.png' }, { src: 'shangxing_t.png', src2: 'shangxing_tred.png' }, { src: 'zhonjiao_t.png', src2: 'zhonjiao_tred.png' }, { src: 'others_t.png', src2: 'others_tred.png' }, { src: 'yinzhang_t.png', src2: 'yinzhang_tred.png' }];
  (0, _index.mbcategory)(param).then(function (result) {
    if (result.code === 0) {
      var category = result.data.mbcategorys;
      category.forEach(function (item, index) {
        if (index === 0) {
          item.icon = imgArray[index].src2;
        } else {
          item.icon = imgArray[index].src;
        }
      });
      state.mobaoCategory = category;
      state.mobaoList = result.data.mblists;
      state.mobaoListLoading = false;
    } else {}
    console.log('墨寶類別%o', result);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.MOBAO_CATEGORY_LOADING, function (state, param) {
  state.mobaoCategoryLoading = true;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.MOBAO_LIST, function (state, param) {
  (0, _index.mb)(param).then(function (result) {
    if (result.code === 0) {
      state.mobaoList = result.data.mblists;
      state.mobaoListLoading = false;
    } else {}
    console.log('墨寶類別%o', result);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.MOBAO_LIST_LOADING, function (state, param) {
  state.mobaoListLoading = true;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.MOBAO_CATEGORY_CHANCE, function (state, id) {
  var imgArray = [{ src: 'fayu_t.png', src2: 'fayu_tred.png' }, { src: 'shuming_t.png', src2: 'shuming_tred.png' }, { src: 'daochang_t.png', src2: 'daochang_tred.png' }, { src: 'fashi_t.png', src2: 'fashi_tred.png' }, { src: 'duiju_t.png', src2: 'duiju_tred.png' }, { src: 'duanju_t.png', src2: 'duanju_tred.png' }, { src: 'yuanxing_t.png', src2: 'yuanxing_tred.png' }, { src: 'shangxing_t.png', src2: 'shangxing_tred.png' }, { src: 'zhonjiao_t.png', src2: 'zhonjiao_tred.png' }, { src: 'others_t.png', src2: 'others_tred.png' }, { src: 'yinzhang_t.png', src2: 'yinzhang_tred.png' }];
  var list = state.mobaoCategory;
  list.forEach(function (item, inedx) {
    if (id === inedx) {
      item.icon = imgArray[inedx].src2;
    } else {
      item.icon = imgArray[inedx].src;
    }
  });
  state.mobaoCategory = list;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.IMG_INDEX, function (state) {
  (0, _index.imgIndex)().then(function (res) {
    var resArray = [];
    var funcArray = [];
    res.forEach(function (item, index) {
      funcArray.push((0, _index.blogmedia)({}, item.featured_media));
      var obj = {
        title: item.title.rendered,
        icon: item.id,
        link: item.link,
        date: item.date
      };
      resArray.push(obj);
    });
    _promise2.default.all(funcArray).then(function (result) {
      resArray.forEach(function (item, i) {
        item.icon = result[i].media_details.sizes.full.source_url;
      });
      state.indexbottom = resArray;
      state.indexbottomLoading = false;
    }, function (fail) {
      console.log('批量请求图片失败了%o', fail);
    });
  }, function (res) {
    console.log('请求五篇文章失败了%o', res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.EBOOK_SEARCH, function (state, param) {
  (0, _index.ebooksearch)(param).then(function (result) {
    state.ebookTreeLoading = false;
    var obj = result.typelist[0];
    var theitem = obj.item;
    theitem.forEach(function (item, index) {
      var a = item.content + '';
      var b = item.content + '';
      if (a === '') {
        item.content = '未找到相應書籍';
        item.src = '未找到相應書籍';
        item.thumbnail = '/pdf/';
      } else {
        var regexp1 = /&gt;/g;
        var regexp2 = /&lt;/g;
        var matchStr1 = a.search(regexp1);
        a = a.substring(matchStr1 + 4);
        var matchStr2 = a.search(regexp2);
        a = a.substring(0, matchStr2);
        a = a.replace(/(^\s*)|(\s*$)/g, '');
        var match1 = b.search(regexp1);
        b = b.substring(0, match1);
        var wps = [];
        var start = 0;
        var pos = b.indexOf(';');

        while (pos > -1) {
          wps.push(b.substr(start, pos - start));
          start = pos + 1;
          pos = b.indexOf(';', pos + 1);
        }
        var c = wps[2];
        c = c.replace(/&quot/g, '');
        c = c.substring(3);
        c = '/' + c;
        // a = a.substring(matchStr1.index, matchStr2.index)
        // a = a.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&apos;/g, "'")
        item.content = a;
        item.src = c;
        item.thumbnail = '/pdf/' + item.thumbnail;
      }
    });
    obj.item = theitem;
    state.ebookItem = obj;
  }, function (res) {
    console.log('網絡查詢失敗了:%o', res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.RSFS_INDEX2, function (state, data) {
  (0, _index.rsfs)(data).then(function (res) {
    if (res.code === 200) {
      state.rsfsTypeList = res.data.typeList;
      state.rsfsList = res.data.list;
      state.rsfsObject = res.data.comprehend;
      state.rsfsTypes = res.data.types;
    }
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.RSFS_TYPELIST, function (state, data) {
  switch (data) {
    case 1:
      state.rsfsList = state.rsfsTypeList.list1;
      break;
    case 2:
      state.rsfsList = state.rsfsTypeList.list2;
      break;
    case 3:
      state.rsfsList = state.rsfsTypeList.list3;
      break;
    case 4:
      state.rsfsList = state.rsfsTypeList.list4;
      break;
    case 5:
      state.rsfsList = state.rsfsTypeList.list5;
      break;
    case 6:
      state.rsfsList = state.rsfsTypeList.list6;
      break;
    case 7:
      state.rsfsList = state.rsfsTypeList.list7;
      break;
    case 8:
      state.rsfsList = state.rsfsTypeList.list8;
      break;
  }
  state.fsTreeLoading = false;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.RSFS_INFO, function (state, data) {
  state.rsfsList.forEach(function (item) {
    if (item.id === data) {
      state.rsfsObject = item;
    }
  });
  state.fsInfoLoading = false;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.RSFS_EXINFO, function (state, data) {
  var theList = [];
  switch (data.type) {
    case 1:
      theList = state.rsfsTypeList.list1;
      break;
    case 2:
      theList = state.rsfsTypeList.list2;
      break;
    case 3:
      theList = state.rsfsTypeList.list3;
      break;
    case 4:
      theList = state.rsfsTypeList.list4;
      break;
    case 5:
      theList = state.rsfsTypeList.list5;
      break;
    case 6:
      theList = state.rsfsTypeList.list6;
      break;
    case 7:
      theList = state.rsfsTypeList.list7;
      break;
    case 8:
      theList = state.rsfsTypeList.list8;
      break;
  }
  theList.forEach(function (item) {
    if (item.id === data.id) {
      state.rsfsObject = item;
    }
  });
  state.fsInfoLoading = false;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.FS_RIGHT_INFO_LOADING, function (state, param) {
  state.fsInfoLoading = true;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.ENLIGHT_INDEX, function (state, paramas) {
  (0, _index.enlightIndex)(paramas).then(function (res) {
    if (res.code === 200) {
      state.enlightTypes = res.data.typeList;
      state.enlightPage = res.data.list;
      state.enlightObject = res.data.list.rows[0];
    }
    state.enlightLoading = false;
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.ENLIGHT_PAGE, function (state, paramas) {
  (0, _index.enlightPage)(paramas).then(function (res) {
    if (res.code === 200) {
      state.enlightPage = res.data.list;
    }
    state.enlightLoading = false;
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.QUERY_ENLIGHT_LIST, function (state, paramas) {
  (0, _index.enlightList)(paramas).then(function (res) {
    if (res.code === 200) {
      state.enlightPage = res.data.list;
    }
    state.enlightLoading = false;
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.ENLIGHT_INFO, function (state, param) {
  state.enlightPage.rows.forEach(function (item) {
    if (item.amtbIndex === param) {
      state.enlightObject = item;
    }
  });
  state.enlightInfoLoading = false;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.ENLIGHT_LOADING, function (state) {
  state.enlightLoading = true;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.ENLIGHT_INFO_LOADING, function (state) {
  state.enlightInfo = { title: '', content: '' };
  state.enlightInfoLoading = true;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.EBOOK_PAGE, function (state, param) {
  (0, _index.ebookPage)(param).then(function (res) {
    if (res.code === 200) {
      state.ebookPage = res.data.list;
    }
    state.ebookTreeLoading = false;
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.EBOOK_INDEX, function (state, param) {
  (0, _index.ebookIndex)(param).then(function (res) {
    if (res.code === 200) {
      state.ebookPage = res.data.list;
      state.ebookTypes = res.data.typeList;
      state.ebookTops = res.data.topList;
    }
    state.ebookTreeLoading = false;
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.EBOOK_TREE_LOADING, function (state, param) {
  state.ebookTreeLoading = true;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.CARD_INDEX, function (state, param) {
  (0, _index.cardIndex)(param).then(function (res) {
    if (res.code === 200) {
      state.cardPage = res.data.list;
      state.cardTypes = res.data.typeList;
    }
    state.wallcardListLoading = false;
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.CARD_PAGE, function (state, param) {
  (0, _index.cardPage)(param).then(function (res) {
    if (res.code === 200) {
      state.cardPage = res.data.list;
    }
    state.wallcardListLoading = false;
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.CARD_DOWN, function (state, param) {
  (0, _index.cardDown)(param).then(function (res) {
    console.log(res);
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.CARD_INDEX_NEW, function (state, param) {
  (0, _index.cardIndexNew)(param).then(function (res) {
    if (res.code === '200') {
      // state.cardPage = res.data.list // ? 改成调用获取接口查询第一页来。
      state.cardTypes = res.data;
      var list = res.data;
      var typelist = [];
      list.forEach(function (item, index) {
        var typeItem = { id: item.id, name: item.name, idname: item.id + '-' + item.name };
        typelist.push(typeItem);
      });
      state.cardTypes = typelist;
      var catalogueId = res.data[0].id;
      if (catalogueId) {
        (0, _index.cardPageNew)({ catalogueId: catalogueId, startPage: 1, pageSize: 20 }).then(function (res1) {
          if (res1.code === '200') {
            state.cardPage = res1.data;
          }
        }, function (res1) {
          console.error(res1);
        });
      }
    }
    state.wallcardListLoading = false;
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.CARD_PAGE_NEW, function (state, param) {
  (0, _index.cardPageNew)(param).then(function (res) {
    if (res.code === '200') {
      state.cardPage = res.data;
    }
    state.wallcardListLoading = false;
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.CARD_DOWN_NEW, function (state, cardId) {
  (0, _index.cardDownNew)(cardId).then(function (res) {
    console.log(res);
  }, function (res) {
    console.error(res);
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.WALLCARD_LIST_LOADING, function (state) {
  state.wallcardListLoading = true;
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.INIT_PLAYER_ORDER, function (state, _ref) {
  var paramer = _ref.paramer,
      sortType = _ref.sortType;

  (0, _zhibo.dianboOrder)(paramer, sortType).then(function (res) {
    if (res.code === 0) {
      state.mediaData = res;
      state.jiangtangInfo = res.jiangtanginfo;
      state.dianbobestserverinfo = res.bestserverinfo;
      state.dianbodoc = res.jiangtanginfo.doc;
      state.playlistindex = res.jiangtanginfo.playlistindex;
      var playlistindex = res.jiangtanginfo.playlistindex;
      state.subtable = res.jiangtanginfo.subtable;
      var host = res.bestserverinfo.domain;
      var list = res.jiangtanginfo.mp4list;
      var list2 = res.jiangtanginfo.mp3list;
      state.mp4total = list.length;
      state.mp3total = list2.length;
      var sourceList = [];
      var mp4list = [];
      var mp3list = [];
      var url = 'https://' + res.bestserverinfo.domain;
      list.forEach(function (item, index) {
        var mp4Item = { name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, number: item.id, poster: item.poster, index: index, title: item.title, item: item, downurl: url + item.fileHttpUrl };
        if (playlistindex === index) {
          mp4Item.isplay = true;
        } else {
          mp4Item.isplay = false;
        }
        mp4list.push(mp4Item);
      });
      list2.forEach(function (item, index) {
        var mp3Item = { name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl };
        if (playlistindex === index) {
          mp3Item.isplay = true;
        } else {
          mp3Item.isplay = false;
        }
        mp3list.push(mp3Item);
      });
      state.mp4list = mp4list;
      state.mp3list = mp3list;
      // state.mp4total = list.length
      // state.mp3total = list2.length
      list.forEach(function (item) {
        var s1 = {
          type: 'application/x-mpegurl',
          src: 'https://' + host + item.fileHlsUrl
        };
        var s2 = {
          type: 'video/mp4',
          src: 'https://' + host + item.fileHttpUrl
        };
        var sourceArray = [s1, s2];
        var sourceItem = { sources: sourceArray };
        sourceList.push(sourceItem);
        state.dianboplayerConfig = {
          ratio: 9 / 16,
          autoplay: false,
          debug: false,
          share: true,
          facebook: true,
          chromecast: true,
          // analytics: 'UA-116844336-2',
          playlist: sourceList,
          hlsjs: {
            safari: false,
            recoverMediaError: true,
            recoverNetworkError: true
          }
        };
        state.dianboLoading = false;
        state.countryCode = res.jiangtanginfo.autocode;
        state.dianbocountry = res.jiangtanginfo.autocode;
        if ((0, _storage.getStore)('hid') == null) {
          var uuid = (0, _storage.genUUID)(5);
          (0, _storage.setStore)('hid', uuid);
          state.hid = uuid;
        } else {
          state.hid = (0, _storage.getStore)('hid');
        }
        if ((0, _storage.getStore)('aid') == null) {
          var uuid2 = Date.now();
          (0, _storage.setStore)('hid', uuid2);
          state.aid = uuid2;
        } else {
          state.aid = (0, _storage.getStore)('aid');
        }
      });
    } else {
      console.log('dianbo shibao');
    }
  }, function (res) {
    console.log('dianbo shibao');
  });
}), (0, _defineProperty3.default)(_CHANGE_META_INFO$INI, _mutationTypes.INIT_PLAYER_MP3_ORDER, function (state, _ref2) {
  var paramer = _ref2.paramer,
      sortType = _ref2.sortType;

  (0, _zhibo.dianboOrder)(paramer, sortType).then(function (res) {
    if (res.code === 0) {
      console.log('dianbo chenggong');
      state.mediaData = res;
      state.jiangtangInfo = res.jiangtanginfo;
      state.dianbobestserverinfo = res.bestserverinfo;
      state.dianbodoc = res.jiangtanginfo.doc;
      state.playlistindex = res.jiangtanginfo.playlistindex;
      var playlistindex = res.jiangtanginfo.playlistindex;
      state.subtable = res.jiangtanginfo.subtable;
      var host = res.bestserverinfo.domain;
      var list = res.jiangtanginfo.mp4list;
      var list2 = res.jiangtanginfo.mp3list;
      state.mp4total = list.length;
      state.mp3total = list2.length;
      var sourceList = [];
      var mp4list = [];
      var mp3list = [];
      var url = 'https://' + res.bestserverinfo.domain;
      list.forEach(function (item, index) {
        var mp4Item = { name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, index: index, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl };
        if (playlistindex === index) {
          mp4Item.isplay = true;
        } else {
          mp4Item.isplay = false;
        }
        mp4list.push(mp4Item);
      });
      list2.forEach(function (item, index) {
        var mp3Item = { name: item.titleshow, itemidparent: item.itemidparent, itemidchildren: item.itemidchildren, voice: item.voice, index: index, number: item.id, poster: item.poster, title: item.title, item: item, downurl: url + item.fileHttpUrl };
        if (playlistindex === index) {
          mp3list.isplay = true;
        } else {
          mp3list.isplay = false;
        }
        mp3list.push(mp3Item);
      });
      state.mp4list = mp4list;
      state.mp3list = mp3list;
      // state.mp4total = list.length
      // state.mp3total = list2.length
      list2.forEach(function (item) {
        var s2 = {
          type: 'audio/mpeg',
          src: 'https://' + host + item.fileHttpUrl
        };
        var sourceArray = [s2];
        var sourceItem = { audio: true, coverImage: item.poster, sources: sourceArray };
        sourceList.push(sourceItem);
      });
      state.dianboplayerConfig = {
        ratio: 9 / 16,
        autoplay: false,
        debug: false,
        share: true,
        facebook: true,
        chromecast: false,
        // analytics: 'UA-116844336-2',
        playlist: sourceList,
        hlsjs: {
          safari: false,
          recoverMediaError: true,
          recoverNetworkError: true
        }
      };
      state.dianboLoading = false;
      state.dianbocountry = res.jiangtanginfo.autocode;
      if ((0, _storage.getStore)('hid') == null) {
        var uuid = (0, _storage.genUUID)(5);
        (0, _storage.setStore)('hid', uuid);
        state.hid = uuid;
      } else {
        state.hid = (0, _storage.getStore)('hid');
      }
      if ((0, _storage.getStore)('aid') == null) {
        var uuid2 = Date.now();
        (0, _storage.setStore)('hid', uuid2);
        state.aid = uuid2;
      } else {
        state.aid = (0, _storage.getStore)('aid');
      }
    } else {
      console.log('dianbo fail');
    }
  }, function (res) {
    console.log('dianbo fail');
  });
}), _CHANGE_META_INFO$INI);

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genUUID = exports.removeStore = exports.getStore = exports.setStore = undefined;

var _stringify = __webpack_require__(228);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 存储localStorage
 */
var setStore = exports.setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = (0, _stringify2.default)(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = exports.getStore = function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
var removeStore = exports.removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};
var genUUID = exports.genUUID = function genUUID(length) {
  return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
};

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

exports.default = {
  name: 'app'
};

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 610:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 612:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 613:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 615:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 618:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 619:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 620:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 621:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(622)
}
var Component = __webpack_require__(226)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(640),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 640:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullPath,
    staticClass: "main"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
module.exports = __webpack_require__(225);


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/element-icons.732389d.ttf";

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/element-icons.535877f.woff";

/***/ })

},[646]);


// WEBPACK FOOTER //
// static/js/app.7b63d6894091284023e8.1747826568907.js